export const comics = [
  {
    id: 'comic-1',
    title: '我独自升级',
    author: 'Chugong / DUBU',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20solo%20leveling%20style%20dark%20fantasy%20warrior%20with%20glowing%20eyes%2C%20dynamic%20action%20pose%2C%20dark%20city%20background%2C%20epic%20manhwa%20art%20style%2C%20cool%20color%20tones%2C%20dramatic%20lighting%2C%20clean%20composition%20on%20simple%20dark%20background&width=800&height=1100&seq=comic-cover-01&orientation=portrait',
    description: '十多年前，世界各地突然出现了连接异次元与这个世界的「传送门」，而其中苏醒的被称为「猎人」的特殊能力者们，则开始以讨伐传送门中的怪物为生。然而，作为最弱E级猎人的成振宇，在一次地下城探索中遭遇了生死危机。',
    category: '热血',
    status: '连载中',
    rating: 9.7,
    views: 3280000,
    updatedAt: '2026-07-03',
    chapters: [
      { num: 201, title: '最终决战（上）', date: '2026-07-03' },
      { num: 200, title: '决战前夕', date: '2026-06-29' },
      { num: 199, title: '最后的准备', date: '2026-06-25' },
      { num: 198, title: '觉醒之力', date: '2026-06-21' },
      { num: 197, title: '极限突破', date: '2026-06-17' },
    ],
  },
  {
    id: 'comic-2',
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20omniscient%20reader%20style%20young%20man%20in%20office%20worker%20suit%20holding%20smartphone%2C%20apocalyptic%20cityscape%20background%2C%20dramatic%20manhwa%20art%20style%2C%20warm%20golden%20and%20dark%20tone%2C%20clean%20composition%20on%20simple%20background&width=800&height=1100&seq=comic-cover-02&orientation=portrait',
    description: '一个普通的上班族金独子，是唯一一个读完了连载十年、共3149话的网络小说《在灭亡的世界中生存的三种方法》的读者。当小说中的末日场景在现实中成真时，他凭借对剧情的了解，在这个残酷的世界中开始了生存之旅。',
    category: '奇幻',
    status: '连载中',
    rating: 9.6,
    views: 2950000,
    updatedAt: '2026-07-02',
    chapters: [
      { num: 235, title: '最后的方案', date: '2026-07-02' },
      { num: 234, title: '星流的真相', date: '2026-06-28' },
      { num: 233, title: '外神降临', date: '2026-06-24' },
      { num: 232, title: '超越星座', date: '2026-06-20' },
      { num: 231, title: '神话级剧情', date: '2026-06-16' },
    ],
  },
  {
    id: 'comic-3',
    title: '美貌理事长',
    author: 'ZIG / KIMJUN',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20style%20elegant%20beautiful%20woman%20in%20business%20attire%2C%20modern%20office%20setting%2C%20soft%20manhwa%20art%20style%2C%20warm%20peach%20and%20cream%20tones%2C%20clean%20composition%20on%20simple%20light%20background&width=800&height=1100&seq=comic-cover-03&orientation=portrait',
    description: '身为高中教师的李贤秀，意外发现新任理事长竟然是自己的初恋女友。曾经单纯的校园恋情，如今演变成了职场上的复杂关系。富家女与普通教师之间，跨越阶级的爱情故事即将展开。',
    category: '恋爱',
    status: '连载中',
    rating: 9.3,
    views: 2180000,
    updatedAt: '2026-07-03',
    chapters: [
      { num: 126, title: '重逢之夜', date: '2026-07-03' },
      { num: 125, title: '误会的真相', date: '2026-06-30' },
      { num: 124, title: '她的秘密', date: '2026-06-26' },
      { num: 123, title: '心跳加速', date: '2026-06-22' },
      { num: 122, title: '靠近的距离', date: '2026-06-18' },
    ],
  },
  {
    id: 'comic-4',
    title: '剑尊归来',
    author: 'STUDIO LICO / LEE YOUNG',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20martial%20arts%20style%20sword%20master%20with%20long%20hair%20in%20traditional%20robe%2C%20ancient%20Korean%20palace%20background%2C%20epic%20manhwa%20art%20style%2C%20cool%20blue%20and%20silver%20tones%2C%20clean%20composition%20on%20simple%20background&width=800&height=1100&seq=comic-cover-04&orientation=portrait',
    description: '被誉为天下第一剑的梅华剑尊，在击败魔教教主后因重伤而亡。然而当他再次睁开眼睛时，发现自己回到了二十年前的少年时代。带着前世所有的武学记忆，他决心在这一世保护所有珍视之人，改写悲剧的命运。',
    category: '武侠',
    status: '连载中',
    rating: 9.5,
    views: 2860000,
    updatedAt: '2026-07-02',
    chapters: [
      { num: 178, title: '天下第一剑', date: '2026-07-02' },
      { num: 177, title: '宿命对决', date: '2026-06-29' },
      { num: 176, title: '剑道巅峰', date: '2026-06-25' },
      { num: 175, title: '师门之秘', date: '2026-06-21' },
      { num: 174, title: '破而后立', date: '2026-06-17' },
    ],
  },
  {
    id: 'comic-5',
    title: '新入社员',
    author: 'ZIKZIN / PARK SOO',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20office%20drama%20style%20young%20businessman%20in%20modern%20suit%2C%20corporate%20office%20background%2C%20clean%20manhwa%20art%20style%2C%20neutral%20gray%20and%20navy%20tones%2C%20clean%20composition%20on%20simple%20background&width=800&height=1100&seq=comic-cover-05&orientation=portrait',
    description: '普通大学毕业生韩志浩，历经千辛万苦终于进入梦想中的大企业。然而入职第一天就发现，这家公司的内部远比他想象的复杂。办公室政治、职场恋情、商业斗争，新入社员的生存挑战正式开始。',
    category: '职场',
    status: '已完结',
    rating: 9.1,
    views: 1560000,
    updatedAt: '2026-06-15',
    chapters: [
      { num: 160, title: '新的开始（完结）', date: '2026-06-15' },
      { num: 159, title: '最后的提案', date: '2026-06-12' },
      { num: 158, title: '升职之路', date: '2026-06-08' },
      { num: 157, title: '危机中的转机', date: '2026-06-04' },
      { num: 156, title: '真正的实力', date: '2026-05-31' },
    ],
  },
  {
    id: 'comic-6',
    title: '神之塔',
    author: 'SIU',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20tower%20of%20god%20style%20mysterious%20boy%20climbing%20a%20massive%20tower%2C%20fantasy%20world%20background%2C%20epic%20manhwa%20art%20style%2C%20purple%20and%20gold%20tones%2C%20clean%20composition%20on%20simple%20background&width=800&height=1100&seq=comic-cover-06&orientation=portrait',
    description: '住在塔底层的少年二十五夜，为了追寻唯一的朋友蕾哈尔，毅然踏入传说中的神之塔。在攀爬塔的过程中，他将面临无数考验，结识各种伙伴与敌人，逐渐揭开这座神秘之塔的真相。',
    category: '奇幻',
    status: '连载中',
    rating: 9.4,
    views: 3120000,
    updatedAt: '2026-07-01',
    chapters: [
      { num: 612, title: '塔顶的秘密', date: '2026-07-01' },
      { num: 611, title: '王的归来', date: '2026-06-28' },
      { num: 610, title: '决战之塔', date: '2026-06-24' },
      { num: 609, title: '命运的齿轮', date: '2026-06-20' },
      { num: 608, title: '新的试炼', date: '2026-06-16' },
    ],
  },
  {
    id: 'comic-7',
    title: '重生之都市修仙',
    author: 'LIM DALL / KANG MI',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cultivation%20style%20handsome%20man%20in%20modern%20city%20with%20mystical%20energy%20surrounding%2C%20urban%20nightscape%20background%2C%20stylish%20manhwa%20art%20style%2C%20golden%20and%20dark%20blue%20tones%2C%20clean%20composition%20on%20simple%20background&width=800&height=1100&seq=comic-cover-07&orientation=portrait',
    description: '仙界第一高手陈凡，渡劫失败后转世重生到地球上一个普通高中生身上。在末法时代的地球，他以仙尊的记忆和经验，从零开始重新修炼。校园、都市、修真，三重世界交织的精彩故事。',
    category: '都市',
    status: '连载中',
    rating: 9.2,
    views: 2450000,
    updatedAt: '2026-07-03',
    chapters: [
      { num: 340, title: '渡劫飞升', date: '2026-07-03' },
      { num: 339, title: '最后的敌人', date: '2026-06-30' },
      { num: 338, title: '九转金丹', date: '2026-06-26' },
      { num: 337, title: '上古遗迹', date: '2026-06-22' },
      { num: 336, title: '天劫降临', date: '2026-06-18' },
    ],
  },
  {
    id: 'comic-8',
    title: '恶役千金',
    author: 'HAN RIVER / YUNA',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20villainess%20style%20elegant%20noblewoman%20in%20Victorian%20gown%2C%20royal%20palace%20ballroom%20background%2C%20romantic%20manhwa%20art%20style%2C%20rose%20pink%20and%20cream%20tones%2C%20clean%20composition%20on%20simple%20background&width=800&height=1100&seq=comic-cover-08&orientation=portrait',
    description: '一觉醒来，我发现自己穿越成了小说中的恶役千金——注定要被王子抛弃、被家族流放的悲惨角色。为了改变命运，我决定先下手为强：主动退婚、发展事业、远离主角团。然而事情的发展却出乎意料……',
    category: '恋爱',
    status: '连载中',
    rating: 9.3,
    views: 1980000,
    updatedAt: '2026-07-02',
    chapters: [
      { num: 118, title: '意外的告白', date: '2026-07-02' },
      { num: 117, title: '命运的改变', date: '2026-06-29' },
      { num: 116, title: '王子的心声', date: '2026-06-25' },
      { num: 115, title: '舞会风波', date: '2026-06-21' },
      { num: 114, title: '新的盟友', date: '2026-06-17' },
    ],
  },
  {
    id: 'comic-9',
    title: 'DR. BRAIN',
    author: 'HONG JACGA / KIM DA',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20psychological%20thriller%20style%20scientist%20with%20intense%20eyes%2C%20dark%20laboratory%20background%2C%20mysterious%20manhwa%20art%20style%2C%20green%20and%20dark%20tones%2C%20clean%20composition%20on%20simple%20dark%20background&width=800&height=1100&seq=comic-cover-09&orientation=portrait',
    description: '天才脑科学家李秀元，在一次实验中意外获得了读取他人记忆的能力。他能通过接触他人大脑来进入对方的记忆世界。然而随着能力的深入，他发现自己卷入了一个巨大的阴谋之中。',
    category: '悬疑',
    status: '已完结',
    rating: 9.5,
    views: 1870000,
    updatedAt: '2026-05-20',
    chapters: [
      { num: 96, title: '最终记忆（完结）', date: '2026-05-20' },
      { num: 95, title: '真相的碎片', date: '2026-05-17' },
      { num: 94, title: '记忆的迷宫', date: '2026-05-13' },
      { num: 93, title: '幕后黑手', date: '2026-05-09' },
      { num: 92, title: '关键线索', date: '2026-05-05' },
    ],
  },
  {
    id: 'comic-10',
    title: '甜蜜的陷阱',
    author: 'LEMON STUDIO / PARK JI',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20sweet%20romance%20style%20couple%20sharing%20dessert%20at%20cafe%2C%20cozy%20cafe%20background%2C%20soft%20manhwa%20art%20style%2C%20pastel%20pink%20and%20mint%20tones%2C%20clean%20composition%20on%20simple%20light%20background&width=800&height=1100&seq=comic-cover-10&orientation=portrait',
    description: '甜品店老板的女儿韩多恩，为了拯救家族店铺，与知名美食评论家姜智勋签订了一份假恋爱协议。然而在一次次制作甜点的过程中，两人的感情渐渐变得真实。甜蜜的陷阱，究竟谁会先陷进去？',
    category: '恋爱',
    status: '连载中',
    rating: 9.0,
    views: 1320000,
    updatedAt: '2026-07-03',
    chapters: [
      { num: 88, title: '甜蜜告白', date: '2026-07-03' },
      { num: 87, title: '蛋糕的秘密', date: '2026-06-30' },
      { num: 86, title: '心跳时刻', date: '2026-06-26' },
      { num: 85, title: '竞争对手', date: '2026-06-22' },
      { num: 84, title: '新的配方', date: '2026-06-18' },
    ],
  },
  {
    id: 'comic-11',
    title: '废柴皇子的逆袭',
    author: 'MOON STUDIO / CHOI SUNG',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20prince%20style%20young%20prince%20in%20royal%20attire%20with%20determined%20expression%2C%20medieval%20castle%20background%2C%20epic%20manhwa%20art%20style%2C%20royal%20blue%20and%20gold%20tones%2C%20clean%20composition%20on%20simple%20background&width=800&height=1100&seq=comic-cover-11&orientation=portrait',
    description: '帝国第三皇子莱恩，天生魔力为零，被所有人视为废柴皇子。然而在接受了一个神秘古老传承之后，他获得了前所未有的力量。从此踏上推翻兄长暴政、拯救帝国的道路。',
    category: '热血',
    status: '连载中',
    rating: 9.4,
    views: 2230000,
    updatedAt: '2026-07-02',
    chapters: [
      { num: 156, title: '登基大典', date: '2026-07-02' },
      { num: 155, title: '决战皇城', date: '2026-06-29' },
      { num: 154, title: '禁术觉醒', date: '2026-06-25' },
      { num: 153, title: '王座之争', date: '2026-06-21' },
      { num: 152, title: '隐藏的实力', date: '2026-06-17' },
    ],
  },
  {
    id: 'comic-12',
    title: '秘密花园',
    author: 'FLOWER STUDIO / HAN SOO',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20garden%20style%20young%20woman%20discovering%20hidden%20garden%2C%20enchanted%20garden%20background%2C%20dreamy%20manhwa%20art%20style%2C%20soft%20green%20and%20lavender%20tones%2C%20clean%20composition%20on%20simple%20background&width=800&height=1100&seq=comic-cover-12&orientation=portrait',
    description: '搬进外婆留下的老宅后，韩素熙在庭院尽头发现了一扇通往秘境花园的门。花园中盛开着世上绝无仅有的奇花异草，每一朵花都承载着一个逝去之人的故事。而守护花园的神秘少年，似乎与外婆有着不为人知的过往。',
    category: '奇幻',
    status: '连载中',
    rating: 9.1,
    views: 980000,
    updatedAt: '2026-07-01',
    chapters: [
      { num: 72, title: '外婆的过去', date: '2026-07-01' },
      { num: 71, title: '花语之谜', date: '2026-06-28' },
      { num: 70, title: '守护者的抉择', date: '2026-06-24' },
      { num: 69, title: '枯萎之花', date: '2026-06-20' },
      { num: 68, title: '新的访客', date: '2026-06-16' },
    ],
  },
];

export const categories = [
  { slug: 'rexue', name: '热血', icon: 'ri-fire-line', count: 1280 },
  { slug: 'lianai', name: '恋爱', icon: 'ri-heart-line', count: 960 },
  { slug: 'qihuan', name: '奇幻', icon: 'ri-magic-line', count: 850 },
  { slug: 'wuxia', name: '武侠', icon: 'ri-sword-line', count: 720 },
  { slug: 'dushi', name: '都市', icon: 'ri-building-line', count: 680 },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line', count: 540 },
  { slug: 'zhichang', name: '职场', icon: 'ri-briefcase-line', count: 320 },
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line', count: 480 },
  { slug: 'kongbu', name: '恐怖', icon: 'ri-ghost-line', count: 260 },
  { slug: 'yundong', name: '运动', icon: 'ri-basketball-line', count: 180 },
];

export const testimonials = [
  {
    id: 't1',
    name: '漫画爱好者小王',
    role: '3年资深读者',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20man%20portrait%20natural%20lighting%20casual%20style%2C%20clean%20simple%20background%2C%20professional%20headshot&width=200&height=200&seq=avatar-01&orientation=squarish',
    content: '这个网站真的改变了我看韩漫的方式！以前到处找资源，画质参差不齐，现在终于有了一个正版高清的平台。更新速度也很快，每天都有新章节，简直是韩漫爱好者的天堂。',
  },
  {
    id: 't2',
    name: '漫画译者小李',
    role: '专业韩漫翻译',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20woman%20portrait%20natural%20lighting%20professional%20style%2C%20clean%20simple%20background%2C%20professional%20headshot&width=200&height=200&seq=avatar-02&orientation=squarish',
    content: '作为从业者，我深知正版授权的重要性。这个平台上的每一部作品都经过了合法授权，翻译质量也非常出色。推荐给所有喜欢韩漫的朋友，支持正版就是支持创作者。',
  },
  {
    id: 't3',
    name: '大学生小张',
    role: '韩漫忠实粉丝',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20young%20student%20portrait%20natural%20lighting%20casual%20style%2C%20clean%20simple%20background%2C%20professional%20headshot&width=200&height=200&seq=avatar-03&orientation=squarish',
    content: '最喜欢这里的分类功能，找漫画特别方便。而且界面设计得很舒服，阅读体验非常好。收藏夹功能也很好用，追的十几部漫画更新都有提醒，不用每天自己盯着了。',
  },
];

export const stats = [
  { value: '12,800+', label: '正版漫画' },
  { value: '3,200万+', label: '累计用户' },
  { value: '98%', label: '好评率' },
  { value: '15+', label: '语种覆盖' },
];